import React, { useEffect, useRef, useState } from "react";

import { Editor } from "@tinymce/tinymce-react";
import { getBaseUrl } from "../helper";
import { BtnComponent } from "./button";
import { PageDialogContent, PageDialogFooter } from "./dialog";
import { SectionHeader } from "./section";

export const TinyEditor = ({
  template_name,
  defaultTemplate,
  document_id,
  is_signed = 0,
  setSelectedLetter = () => {},
  signTemplate = () => {},
  signingLetter = false,
  readOnly = false,
  printAction = null,
}) => {
  const { auth: authToken } = JSON.parse(localStorage.getItem("auth"));
  const [loadingState, setLoadingState] = useState("save");
  const editorRef = useRef(null);
  const [content, setContent] = useState("");
  const log = () => {
    if (editorRef.current) {
      console.log(editorRef.current.getContent());
    }
  };
  const onEditorChange = function (a, editor) {
    // console.log(a);
    setContent(a);
    setText(editor.getContent({ format: "text" }));
    //console.log(editor);
  };
  let url = getBaseUrl();
  let fileUrl = `${url}/documents/view.json?id=${document_id}&token=${authToken}&tz=${new Date().getTimezoneOffset()}`;

  const [text, setText] = useState();

  useEffect(() => {
    if (defaultTemplate) setContent(defaultTemplate);
  }, [defaultTemplate]);

  const editorActions = [
    {
      text: "Cancel",
      btnType: "default",
      onClick: () => setSelectedLetter(null),
    },
    {
      text: "Save",
      onClick: () => {
        setLoadingState("save");
        signTemplate(editorRef.current.getContent());
      },
      disabled: signingLetter,
      loading: loadingState == "save" && signingLetter,
    },
    {
      text: is_signed ? "UnSign" : "Sign",
      onClick: () => {
        setLoadingState("sign");
        signTemplate(editorRef.current.getContent(), is_signed == 0 ? 1 : 0);
      },
      disabled: signingLetter,
      loading: loadingState == "sign" && signingLetter,
    },
    {
      text: `${is_signed ? "Save" : "Sign"} & Preview`,
      onClick: () => {
        setLoadingState("sign");
        signTemplate(editorRef.current.getContent(),is_signed == 1 ? null : 1 , "preview");
      },
      disabled: signingLetter,
      loading: loadingState == "sign" && signingLetter,
    },
  ];
  if (is_signed == 1) {
    editorActions.push({
      text: "Print",
      onClick: () =>
        printAction ? printAction() : window.open(fileUrl, "_blank"),
      disabled: signingLetter,
    });
    editorActions.push({
      text: "Save and Share",
      onClick: () => {
        setLoadingState("save");
        signTemplate(editorRef.current.getContent(), null, "attach_in_msg");
      },
      disabled: signingLetter,
      loading: loadingState == "save" && signingLetter,
    });
  }
  if (is_signed != 1) {
    editorActions.push({
      text: "Sign & Share",
      onClick: () => {
        setLoadingState("sign");
        signTemplate(
          editorRef.current.getContent(),
          is_signed == 0 ? 1 : 0,
          "attach_in_msg"
        );
      },
      loading: loadingState == "sign" && signingLetter,
    });
  }
  return (
    <>
      <PageDialogContent contentScroll={true}>
        <SectionHeader title={template_name} />
        {/* <p dangerouslySetInnerHTML={{ __html: letter?.template }}></p> */}
        <Editor
          onEditorChange={onEditorChange}
          //initialValue={content}
          //outputFormat="text"
          disabled={readOnly}
          value={content}
          onInit={(evt, editor) => (editorRef.current = editor)}
          // initialValue="<p>This is the initial content of the editor.</p>"
          init={{
            height: 900,

            menubar: false,
            plugins: "lists media table wordcount image imagetools",
            toolbar:
              "undo redo | bold italic underline strikethrough | Superscript Subscript | fontfamily fontsize blocks | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | image template link anchor codesample | table | wordcount",
            content_style:
              "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
            emoticons_append: {
              custom_mind_explode: {
                keywords: ["brain", "mind", "explode", "blown"],
                char: "🤯",
              },
            },
          }}
        />
      </PageDialogContent>
      <PageDialogFooter>
        {editorActions?.map((btn) => (
          <BtnComponent {...btn} />
        ))}
      </PageDialogFooter>
    </>
  );
  // return (
  //   <>
  //     <Editor
  //       apiKey='your-api-key'
  //       onInit={(evt, editor) => editorRef.current = editor}
  //       initialValue="<p>This is the initial content of the editor.</p>"
  //       init={{
  //         height: 500,
  //         menubar: false,
  //         plugins: [
  //           'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
  //           'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
  //           'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
  //         ],
  //         toolbar: 'undo redo | blocks | ' +
  //           'bold italic forecolor | alignleft aligncenter ' +
  //           'alignright alignjustify | bullist numlist outdent indent | ' +
  //           'removeformat | help',
  //         content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
  //       }}
  //     />
  //     <button onClick={log}>Log editor content</button>
  //   </>
  // );
};
